<template>
  <div>
    <input v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="label" type="password" :autocomplete="autocomplete" />
    <label>
      {{ label }}
    </label>
    <span
      v-tooltip="{
        content: `Det skal være minimum 8 karakterer<br /> langt og indeholde mindst et lille bogstav,<br /> et stort bogstav, et tal og et special tegn`,
        placement: 'top-center',
      }"
      class="des-tooltip"
    >
    </span>
    <small class="error">{{ validation }}</small>
  </div>
</template>
<script>
export default {
  name: 'Password',
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    validation: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      autocomplete: null,
    },
  },
}
</script>
